'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _FilterCollection = require('../../Filters/FilterCollection');

var _FilterCollection2 = _interopRequireDefault(_FilterCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _FilterCollection2.default)('lots')('Community', {
  filter: function filter(lot, _ref) {
    var values = _ref.values,
        community = _ref.community;

    return (values || []).map(function (v) {
      return v.value;
    }).includes(community._id);
  },

  dependencies: ['community'],
  collectValues: function collectValues(lots, _ref2) {
    var communities = _ref2.communities;

    var communityNames = _fp2.default.flow(_fp2.default.sortBy('name'), _fp2.default.map(function (community) {
      return {
        value: community._id,
        community: community
      };
    }))(communities);

    return communityNames;
  },

  labelRender: function labelRender(_ref3) {
    var community = _ref3.community;
    return _fp2.default.get('name', community);
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Lots/filters/Community.js
// module id = 923
// module chunks = 0